import { useTranslation } from "react-i18next";
import { Modal } from "../ui/Modal";
import { ZReport } from "./ZReport";

/** Header shortcut to view/close the terminal's shift (the same card used in the admin hub). */
export function ShiftDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useTranslation();
  return (
    <Modal open={open} onClose={onClose} title={t("shift.manage")} size="md">
      <ZReport />
    </Modal>
  );
}
